<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    class="icon-svg icon-cart"
  >
    <path
      class="fill"
      fill-rule="evenodd"
      d="M9.393 21.207c.41.41.41 1.075 0 1.485-.41.41-1.075.41-1.485 0-.41-.41-.41-1.075 0-1.485.41-.41 1.075-.41 1.485 0zm7 0c.41.41.41 1.075 0 1.485-.41.41-1.075.41-1.485 0-.41-.41-.41-1.075 0-1.485.41-.41 1.075-.41 1.485 0zM22.3 2c.386 0 .7.314.7.7 0 .386-.314.7-.7.7h-.918c-.343 0-.633.246-.69.583L18.23 18.45c-.172 1.012-1.042 1.748-2.07 1.748H6.9c-.385 0-.699-.313-.699-.7 0-.386.314-.7.7-.7h9.259c.343 0 .633-.245.69-.583L17.229 16H6.79c-1.61 0-3.004-1.09-3.395-2.65L2.042 7.934c-.09-.363-.034-.74.158-1.06.192-.322.498-.549.86-.64.11-.027.225-.041.34-.041h15.494l.417-2.447C19.483 2.735 20.354 2 21.38 2h.919zm-3.643 5.595H3.4l1.352 5.414c.235.936 1.072 1.59 2.037 1.59h10.675l1.192-7.004z"
    />
  </svg>
</template>
